import SidebarComponent from 'app/components/SidebarComponent/SidebarComponent';
import React from 'react';
import { Outlet } from 'react-router-dom';
import './SidebarLayout.scss';

const SidebarLayout = function init(): React.ReactElement {
    return (
        <div className="body-content">
            <SidebarComponent />
            <Outlet />
        </div>
    );
};

export default SidebarLayout;
